/**
 * Loading state
 */
export var Loading;
(function (Loading) {
    Loading["LOADING"] = "LOADING";
    Loading["LOADED"] = "LOADED";
})(Loading || (Loading = {}));
/**
 * Returns loading's classname depending on loading type
 * @param loadingType {string} - Loading type
 * @returns {string} - Loading value
 */
export const getLoadingClassName = (loadingType) => {
    switch (loadingType) {
        case 'LOADING':
            return 'loading';
        case 'LOADED':
            return 'loaded';
        default:
            return '';
    }
};
//# sourceMappingURL=Loadable.js.map